import { useMemo, useEffect } from 'react'
import { useField, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import {
  activeTargetPests,
  selectAllTargetPests,
} from '@user/store/targetPests/slice'
import type { TargetPestsProps } from '../TargetPests'

export function useData(props: TargetPestsProps) {
  const { required } = props

  const name = 'targetPests'
  const { setFieldValue } = useFormikContext()

  const [{ value }, { error, touched }] = useField<string[]>({
    name: 'targetPests',
    validate: (value) => {
      if (required && (!value || value.length === 0)) {
        return 'Required'
      }
    },
  })

  const allTargetPests = useSelector(selectAllTargetPests)

  const activePests = useMemo(
    () =>
      activeTargetPests(allTargetPests).map((p) => ({
        value: p.id,
        label: p.name,
      })),
    [allTargetPests],
  )

  useEffect(() => {
    if (value.length == 0 && activePests?.length == 1 && required) {
      setFieldValue(
        name,
        activePests?.map((row) => row.value),
      )
    }
  }, [activePests, required, value])

  const selectedPests = useMemo(
    () =>
      value.reduce((acc, id) => {
        const pest = activePests.find((x) => x.value === id)
        if (pest) return [...acc, pest]
        return acc
      }, []),
    [activePests, value],
  )

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  return {
    showError,
    helperText,
    value: selectedPests,
    options: activePests,
  }
}
